import { memberTagList } from '@/utils/constant'

export const useVipLogo = () => {
  const JC_VENDOR_CODE = 'JC Vendor'

  const store = useMySystemStore()
  const route = useRoute()
  const isEnglish = computed(() => {
    return store.language === 'en-US'
  })
  const isCn = computed(() => {
    return store.language === 'zh-CN' || route.params.lang === 'cn'
  })
  // const memberTagList = [
  //   {
  //     url: 'https://resources.jctrans.com/res/era-h5/h5/img/dangerous@2x.png',
  //     color: '#D80E0E',
  //     name: 'dangerous',
  //     code: 'JC Dangerous Goods',
  //   }, // JC Dangerous Goods
  //   {
  //     url: 'https://resources.jctrans.com/res/era-h5/h5/img/ecommerce@2x.png',
  //     color: '#3C35C4',
  //     name: 'ecommerce',
  //     code: 'JC eCommerce',
  //   }, // JC e-Commerce
  //   {
  //     url: 'https://resources.jctrans.com/res/era-h5/h5/img/elite@2x.png',
  //     color: '#4A2D13',
  //     name: 'elite',
  //     code: 'JC Elite',
  //   }, // JC Elite
  //   {
  //     url: 'https://resources.jctrans.com/res/era-h5/h5/img/premium@2x.png',
  //     color: '#EC661B',
  //     name: 'premium',
  //     code: 'GCP',
  //   }, // JC Premium
  //   {
  //     url: 'https://resources.jctrans.com/res/era-h5/h5/img/project@2x.png',
  //     color: '#003BB9',
  //     name: 'project',
  //     code: 'JC Projects',
  //   }, // JC Projects
  //   {
  //     url: 'https://resources.jctrans.com/res/era-h5/h5/img/railway@2x.png',
  //     color: '#825034',
  //     name: 'railway',
  //     code: 'JC Railway',
  //   }, // JC Railway
  //   {
  //     url: 'https://resources.jctrans.com/res/era-h5/h5/img/rising@2x.png',
  //     color: '#396F09',
  //     name: 'rising',
  //     code: 'GRP',
  //   }, // JC Rising
  //   {
  //     url: 'https://resources.jctrans.com/res/era-h5/h5/img/vendor@2x.png',
  //     color: '#265438',
  //     name: 'vendor',
  //     code: JC_VENDOR_CODE,
  //   }, // JC Vendor | JC Vendor Consulting Services | JC Vendor Finance Services | JC Vendor IT Services | JC Vendor Transportation | JC Vendor Warehousing
  // ]

  function getVipIconByCode(code = ''): any {
    const JC_VENDOR_CODE = 'JC Vendor'
    const isVendor = code.indexOf(JC_VENDOR_CODE) !== -1

    return (
      memberTagList.find(
        (item) => item.code === (isVendor ? JC_VENDOR_CODE : code),
      ) || ''
    )
  }

  function getShopBannerBySkinCode(skinCode = ''): any {
    if (!skinCode) {
      return ''
    }
    const shopBannerItem = memberTagList.find(
      (item) => item.skinCode === skinCode,
    )
    return shopBannerItem || {}
  }

  const setDefaultCompanyLogo = (url = '') => {
    return (
      url || 'https://resources.jctrans.com/res/jc/pc/img/comLogo-default.png'
    )
  }

  function getVipHeaderLogoClass(code: string) {
    const map: any = {
      'JC eCommerce': 'vip-header-code-4',
      'JC Projects': 'vip-header-code-7',
      'JC Dangerous Goods': 'vip-header-code-2',
      GRP: 'vip-header-code-5',
      GCP: 'vip-header-code-3',
      'JC Rising': 'vip-header-code-5',
      'JC Premium': 'vip-header-code-3',
      'JC Railway': 'vip-header-code-6',
      'JC Elite': 'vip-header-code-1',
      'JC Vendor': 'vip-header-code-8', // JC Vendor
      'JC Vendor Consulting Services': 'vip-header-code-8-1', // JC Vendor Consulting Services
      'JC Vendor Finance Services': 'vip-header-code-8-2', // JC Vendor Finance Services
      'JC Vendor IT Services': 'vip-header-code-8-3', // JC Vendor IT Services
      'JC Vendor Transportation': 'vip-header-code-8-4', // JC Vendor Transportation
      'JC Vendor Warehousing': 'vip-header-code-8-5', // JC Vendor Warehousing
    }
    return map[code] || ''
  }

  function getVipHeaderAccountLogoClass(code: string) {
    const map: any = {
      'JC eCommerce': 'vip-account-code-4',
      'JC Projects': 'vip-account-code-7',
      'JC Dangerous Goods': 'vip-account-code-2',
      GRP: 'vip-account-code-5',
      GCP: 'vip-account-code-3',
      'JC Rising': 'vip-account-code-5',
      'JC Premium': 'vip-account-code-3',
      'JC Railway': 'vip-account-code-6',
      'JC Elite': 'vip-account-code-1',
      'JC Vendor': 'vip-account-code-8', // JC Vendor
      'JC Vendor Consulting Services': 'vip-account-code-8-1', // JC Vendor Consulting Services
      'JC Vendor Finance Services': 'vip-account-code-8-2', // JC Vendor Finance Services
      'JC Vendor IT Services': 'vip-account-code-8-3', // JC Vendor IT Services
      'JC Vendor Transportation': 'vip-account-code-8-4', // JC Vendor Transportation
      'JC Vendor Warehousing': 'vip-account-code-8-5', // JC Vendor Warehousing
      QSP: isEnglish.value ? 'vip-account-free-en' : 'vip-account-free-cn',
      TSP: isEnglish.value ? 'vip-account-free-en' : 'vip-account-free-cn',
      CCP: isEnglish.value ? 'vip-account-free-en' : 'vip-account-free-cn',
      CSP: isEnglish.value ? 'vip-account-free-en' : 'vip-account-free-cn',
    }
    return map[code] || ''
  }

  function getOverseaVipHeaderAccountLogoClass(code: string) {
    const map: any = {
      'JC eCommerce': 'vip-account-code-4',
      'JC Projects': 'vip-account-code-7',
      'JC Dangerous Goods': 'vip-account-code-2',
      GRP: 'vip-account-code-5',
      GCP: 'vip-account-code-3',
      'JC Rising': 'vip-account-code-5',
      'JC Premium': 'vip-account-code-3',
      'JC Railway': 'vip-account-code-6',
      'JC Elite': 'vip-account-code-1',
      'JC Vendor': 'vip-account-code-8', // JC Vendor
      'JC Vendor Consulting Services': 'vip-account-code-8-1', // JC Vendor Consulting Services
      'JC Vendor Finance Services': 'vip-account-code-8-2', // JC Vendor Finance Services
      'JC Vendor IT Services': 'vip-account-code-8-3', // JC Vendor IT Services
      'JC Vendor Transportation': 'vip-account-code-8-4', // JC Vendor Transportation
      'JC Vendor Warehousing': 'vip-account-code-8-5', // JC Vendor Warehousing
      // QSP: isEnglish.value ? 'vip-account-free-en' : 'vip-account-free-cn',
      // TSP: isEnglish.value ? 'vip-account-free-en' : 'vip-account-free-cn',
      // CCP: isEnglish.value ? 'vip-account-free-en' : 'vip-account-free-cn',
      // CSP: isEnglish.value ? 'vip-account-free-en' : 'vip-account-free-cn',
    }
    return map[code] || ''
  }

  function getVipLogoClass(code: string) {
    const map: any = {
      'JC eCommerce': 'vip-code-4',
      'JC Projects': 'vip-code-7',
      'JC Dangerous Goods': 'vip-code-2',
      GRP: 'vip-code-5',
      GCP: 'vip-code-3',
      'JC Rising': 'vip-code-5',
      'JC Premium': 'vip-code-3',
      'JC Railway': 'vip-code-6',
      'JC Elite': 'vip-code-1',
      'JC Vendor': 'vip-code-8', // JC Vendor
      'JC Vendor Consulting Services': 'vip-code-8-1', // JC Vendor Consulting Services
      'JC Vendor Finance Services': 'vip-code-8-2', // JC Vendor Finance Services
      'JC Vendor IT Services': 'vip-code-8-3', // JC Vendor IT Services
      'JC Vendor Transportation': 'vip-code-8-4', // JC Vendor Transportation
      'JC Vendor Warehousing': 'vip-code-8-5', // JC Vendor Warehousing
    }
    return map[code] || ''
  }

  const myUserStore = useMyUserStore()
  const isLogin = computed(() => {
    return Boolean(myUserStore.userId)
  })
  function handleDownload(fileUrl: string) {
    if (isLogin.value) {
      downFile(fileUrl || '')
    } else {
      go2LoginPage(route.fullPath)
    }
  }
  return {
    isEnglish,
    isCn,

    getVipIconByCode,
    setDefaultCompanyLogo,
    getShopBannerBySkinCode,

    getVipHeaderLogoClass,
    getVipLogoClass,
    getVipHeaderAccountLogoClass,
    getOverseaVipHeaderAccountLogoClass,
    handleDownload,
  }
}
